import { mapState, mapActions } from 'vuex'
import * as storage from '@/modules/auth/storage'
import util from '@/util'
import mensagens from '@/util/mensagens'
import { obterImagem } from '@/util/imagem'
import { BToast, BSpinner } from 'bootstrap-vue'
import PainelAcesso from '@/components/layout/painelAcesso/PainelAcesso.vue'
import { loginMixin } from '@/modules/login/mixins'

export default {
  mixins: [loginMixin],
  name: 'alertaVencimento',
  components: {
    'b-toast': BToast,
    'b-spinner': BSpinner,
    PainelAcesso
  },
  computed: {
    ...mapState('auth', ['regrasLogin', 'dadosAlertaVencimento', 'representanteLegal']),
    obterLogo () {
      return obterImagem('logo-mirt.svg')
    },
    arrayDadosAlertaVencimento () {
      const dadosAlertaVencimento = JSON.parse(this.dadosAlertaVencimento)
      return dadosAlertaVencimento
    },
    obterMensagemBloqueio () {
      const dataBloqueioFormatada = this.arrayDadosAlertaVencimento.dataBloqueio
      if (util.valorEhNulo(dataBloqueioFormatada)) return

      const dataBloqueio = new Date(dataBloqueioFormatada)
      const dataReferencia = new Date()

      if (dataReferencia < dataBloqueio) {
        const dataBloqueioFormatada = util.formatarData(dataBloqueio)
        return `Importante: O acesso será bloqueado em ${dataBloqueioFormatada} caso a pendência não seja regularizada.`
      }
    },

    temVencimentoReferenteContratoPrincipal () {
      const vencimentoReferenteContratoPrincipal = this.arrayDadosAlertaVencimento?.vencimentoReferenteContratoPrincipal
      return !!vencimentoReferenteContratoPrincipal
    },
    temPagamentoPendente () {
      if (util.valorVazio(this.regrasLogin)) {
        return null
      }
      const pendenciasLogin = JSON.parse(this.regrasLogin)
      return pendenciasLogin.pagamentoPendente
    }
  },
  data: () => {
    return {
      flagsDeControle: {
        manipulandoDados: {
          status: false,
          mensagem: ''
        }
      }
    }
  },

  mounted () {
  },

  methods: {
    ...mapActions('auth', ['ActionSetRegrasLogin']),

    async confirmarNotificacao (callback = null, efetuarAutenticacao = true) {
      this.definirFlagManipulandoDados(true, mensagens.salvandoDadosCadastro)
      try {
        const resposta = await this.axios.post('/manager/confirmar/alerta-vencimento')
        if (resposta.data.retorno.sucesso === true) {
          this.emitirEventoFinalizacao(callback, efetuarAutenticacao)
          return
        }
        util.criarAlertaToastDeErro(this, 'Aviso', mensagens.falhaServidorSalvandoDados)
      } catch (e) {
        util.criarAlertaToastDeErro(this, 'Aviso', mensagens.falhaServidorSalvandoDados)
      }
      this.definirFlagManipulandoDados(false, '')
    },

    async resolverPendenciaFatura () {
      if (!this.representanteLegal) return

      this.confirmarNotificacao(this.redirecionarVencimento, false)
    },

    definirFlagManipulandoDados (status, mensagem) {
      this.flagsDeControle.manipulandoDados.status = status
      this.flagsDeControle.manipulandoDados.mensagem = mensagem
    },
    redirecionarVencimento () {
      const regrasLogin = Object.values(JSON.parse(this.regrasLogin))
      const temPendenciaLogin = regrasLogin.some((pendencia) => pendencia === true)
      if (temPendenciaLogin) return

      const idFaturaVencida = this.arrayDadosAlertaVencimento?.idUltimaFatura
      this.ActionSetRegrasLogin('')
      storage.deleteRegrasLogin()

      if (this.temVencimentoReferenteContratoPrincipal) {
        this.redirecionarVencimentoContratoPrincipal(idFaturaVencida)
      } else {
        this.redirecionarVencimentosAdicionais(idFaturaVencida)
      }
    },

    async emitirEventoFinalizacao (callback = null, efetuarAutenticacao = true) {
      const pendenciasLogin = JSON.parse(this.regrasLogin)
      pendenciasLogin.alertarSobreVencido = false
      this.ActionSetRegrasLogin(JSON.stringify(pendenciasLogin))
      this.$emit('finalizandoPendencia', callback, efetuarAutenticacao)
    }
  }
}
